import * as React from "react";
// UI Frameworks
import { Alert as AntAlert } from "antd";
import { AlertProps } from "antd/lib/alert";

interface IProps extends AlertProps {
	children?: React.ReactNode;
}
const Alert: React.FC<IProps> = ({ children, ...restProps }) => {
	return <AntAlert {...restProps}>{children}</AntAlert>;
};

export default Alert;
